import angular from 'angular';
import jasperReport from './jasperReport';
import './style.scss';

export default angular
  .module('components.jasperReport', [])
  .component('jasperReport', jasperReport).name;
